/* Hover-open for desktop header dropdowns and the mega panel
   (reference behavior). Pointer-only and desktop-only; click and
   keyboard paths keep Dawn's native details behavior. */
(function () {
  if (window.vipMegaHoverBound) return;
  window.vipMegaHoverBound = true;

  const media = window.matchMedia('(hover: hover) and (min-width: 990px)');

  const bind = () => {
    document.querySelectorAll('.header__inline-menu header-menu > details').forEach((details) => {
      if (details.dataset.vipHover) return;
      details.dataset.vipHover = 'true';
      const scope = details.closest('header-menu');
      let closeTimer;
      scope.addEventListener('mouseenter', () => {
        if (!media.matches) return;
        clearTimeout(closeTimer);
        details.setAttribute('open', '');
        const summary = details.querySelector('summary');
        if (summary) summary.setAttribute('aria-expanded', 'true');
      });
      scope.addEventListener('mouseleave', () => {
        if (!media.matches) return;
        closeTimer = setTimeout(() => {
          details.removeAttribute('open');
          const summary = details.querySelector('summary');
          if (summary) summary.setAttribute('aria-expanded', 'false');
        }, 150);
      });
    });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', bind);
  } else {
    bind();
  }
  document.addEventListener('shopify:section:load', bind);
})();
